__turbopack_context__.v({
  "btns-row": "statusModal-module-scss-module__RByH9W__btns-row",
  "buttons-con": "statusModal-module-scss-module__RByH9W__buttons-con",
  "claim-no-con": "statusModal-module-scss-module__RByH9W__claim-no-con",
  "claim-no-main-con": "statusModal-module-scss-module__RByH9W__claim-no-main-con",
  "copy-icon-con": "statusModal-module-scss-module__RByH9W__copy-icon-con",
  "img": "statusModal-module-scss-module__RByH9W__img",
  "img-con": "statusModal-module-scss-module__RByH9W__img-con",
  "status-modal-content-con": "statusModal-module-scss-module__RByH9W__status-modal-content-con",
  "status-modal-content-img-con": "statusModal-module-scss-module__RByH9W__status-modal-content-img-con",
  "status-modal-main-con": "statusModal-module-scss-module__RByH9W__status-modal-main-con",
  "sub-title-con": "statusModal-module-scss-module__RByH9W__sub-title-con",
  "title-con": "statusModal-module-scss-module__RByH9W__title-con",
  "title-subtitle-con": "statusModal-module-scss-module__RByH9W__title-subtitle-con",
});
